WB.Routing = WB.Routing ||{};

WB.Routing.RoutingHistory = function($route) {

    this.history = [];

    this.all = function() {
        return this.history;
    };

    this.get = function(index) {
        index = index || 0;
        const historyNow = this.history[index];
        return historyNow;
    };

    this.add = function(route) {
        route = angular.copy(route || $route.current);
        this.history.unshift(route);
    };

    this.replace = function(route, index) {
        route = angular.copy(route || $route.current);
        index = index || 0;
        this.history[index] = route;
    };

    this.getPreviousStandardRoute = function() {
        var previousRoute = null;
        for (var i = 0; i < this.history.length; i++) {
            if (!this.history[i].locals.popup) {
                previousRoute = this.history[i];
                break;
            }
        }
        return previousRoute;
    };

};
WB.Routing.RoutingHistory.$inject = ['$route'];

WB.App.service('RoutingHistory', WB.Routing.RoutingHistory);
